<template>
  <div class="navbar">
    <div class="container">
      <ul class="nav">
        <li class="nav-item">
          <router-link to="/#donate" class="nav-link">Donate</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/our-story" class="nav-link">Our Story</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/#events" class="nav-link">Events</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/gallery" class="nav-link">Gallery</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/our-team" class="nav-link">Our Team</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/#contact" class="nav-link">Contact</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navigation'
}
</script>



// WEBPACK FOOTER //
// Navigation.vue?05be037d